/**
 * TIVA — Masque les logos de paiement du thème.
 * 10/10/2026 : Apple Pay, Shop Pay et PayPal (paiement express) ne sont plus masqués, sur la fiche et au panier.
 * À inclure dans layout/theme.liquid :
 * <script src="{{ 'tiva-hide-payment.js' | asset_url }}" defer></script>
 */
(function () {
  var SELECTORS = [
    'payment-terms',
    'shopify-payment-terms',
    'defer-icons',
    '.product__payment-terms',
    '[class*="payment-terms"]',
    '[class*="payment-icon"]',
    '[class*="payment_icon"]',
    '.list--payment-icons',
    'ul.list.payment-list',
    '.payment-icons',
  ];

  function killPaymentIcons() {
    SELECTORS.forEach(function (sel) {
      try {
        document.querySelectorAll(sel).forEach(function (el) {
          el.style.setProperty('display', 'none', 'important');
          el.setAttribute('hidden', '');
          el.setAttribute('aria-hidden', 'true');
        });
      } catch (e) {}
    });
  }

  // Immédiat
  killPaymentIcons();

  // Après chargement DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', killPaymentIcons);
  }

  // Retries pour les injections async Shopify (Shop Pay, Apple Pay, etc.)
  [100, 300, 600, 1000, 1800, 3000].forEach(function (ms) {
    setTimeout(killPaymentIcons, ms);
  });

  // MutationObserver — capture les injections en temps réel
  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          killPaymentIcons();
          break;
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    // Arrêt après 8s
    setTimeout(function () { observer.disconnect(); }, 8000);
  }

  // Shopify theme editor
  document.addEventListener('shopify:section:load', killPaymentIcons);
})();
